























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Widget from "@/shared/components/Widget.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import HsabEnrollmentSettingsForm from "@/employee/components/settings/hsaBank/HsabEnrollmentSettingsForm.vue";
import { HsabEnrollmentSettingsUpdateRequest } from "@/shared/types";

  @Component({
    components: {
      HsabEnrollmentSettingsForm,
      Widget,
      GenericLoadingSpinner,
    }
  })
  export default class HsabEnrollmentSettings extends Vue {
    hsabEnrollmentStore = useHsabEnrollmentStore();
    hsabAccountsStore = useHsabAccountsStore();
    isEditing = false;

    mounted () {
     this.hsabEnrollmentStore.loadHsabEnrollmentSettings();
    }
    onEditClicked () {
      this.isEditing = true;
    }
    handleEditClosed () {
      this.isEditing = false;
    }
    handleSave (newSettings: HsabEnrollmentSettingsUpdateRequest) {
       this.isEditing = false;
       this.hsabEnrollmentStore.settingsSavedSuccessfully(newSettings);
     }
  }
